import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@frontegg/react';
import { ENVIRONMENTS_INTEGRATIONS } from '@elementary/common-ui/constants/queryKeys';
import * as api from '../services/settingsApi';

const useIntegrations = () => {
  const { isAuthenticated } = useAuth();

  const { data, isLoading } = useQuery(
    [ENVIRONMENTS_INTEGRATIONS],
    api.fetchAllEnvironmentsIntegrations,
    { enabled: isAuthenticated },
  );

  return { integrations: data, isLoading };
};

export default useIntegrations;
